var exports = {
  "Mx": "PageLayout__J-d9nn",
  "az": "Box__UfIbFv",
  "R0": "ArchiveList__R5tIf6",
};

module.exports = exports;
